
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.5.0
 * Query Engine version: 173f8d54f8d52e692c7e27e72a88314ec7aeff60
 */
Prisma.prismaVersion = {
  client: "6.5.0",
  engine: "173f8d54f8d52e692c7e27e72a88314ec7aeff60"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.AnnouncementScalarFieldEnum = {
  id: 'id',
  title: 'title',
  bannerFileKey: 'bannerFileKey',
  description: 'description',
  visibilityStatus: 'visibilityStatus',
  visibilityStartDate: 'visibilityStartDate',
  visibilityEndDate: 'visibilityEndDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.RelationLoadStrategy = {
  query: 'query',
  join: 'join'
};

exports.Prisma.CalendarScalarFieldEnum = {
  id: 'id',
  name: 'name',
  school: 'school',
  calendlyLink: 'calendlyLink',
  visibilityStatus: 'visibilityStatus',
  visibilityStartDate: 'visibilityStartDate',
  visibilityEndDate: 'visibilityEndDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CourseCategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  japaneseDescription: 'japaneseDescription',
  bannerFileKey: 'bannerFileKey',
  isKAPlus: 'isKAPlus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CourseGradeScalarFieldEnum = {
  id: 'id',
  code: 'code',
  name: 'name',
  color: 'color',
  isKAPlus: 'isKAPlus',
  relatedKAPlusCourseGradeId: 'relatedKAPlusCourseGradeId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CourseSkillScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  japaneseDescription: 'japaneseDescription',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CourseSkillOnCourseScalarFieldEnum = {
  courseId: 'courseId',
  skillId: 'skillId'
};

exports.Prisma.CourseGradeOnCourseScalarFieldEnum = {
  courseId: 'courseId',
  gradeId: 'gradeId'
};

exports.Prisma.CourseScalarFieldEnum = {
  id: 'id',
  name: 'name',
  year: 'year',
  type: 'type',
  color: 'color',
  includeBreakWeeks: 'includeBreakWeeks',
  iconFileKey: 'iconFileKey',
  bannerFileKey: 'bannerFileKey',
  durationMinutes: 'durationMinutes',
  printableMaterials: 'printableMaterials',
  isPaid: 'isPaid',
  recurrence: 'recurrence',
  categoryId: 'categoryId',
  visibilityStatus: 'visibilityStatus',
  visibilityStartDate: 'visibilityStartDate',
  visibilityEndDate: 'visibilityEndDate',
  description: 'description',
  japaneseDescription: 'japaneseDescription',
  studentDescription: 'studentDescription',
  isStudyBuddyEnabled: 'isStudyBuddyEnabled',
  contentCreatorId: 'contentCreatorId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.CourseThemeScalarFieldEnum = {
  id: 'id',
  name: 'name',
  startWeekIndex: 'startWeekIndex',
  endWeekIndex: 'endWeekIndex',
  description: 'description',
  japaneseDescription: 'japaneseDescription',
  courseId: 'courseId'
};

exports.Prisma.StudentEnrollmentInClassScalarFieldEnum = {
  studentUserId: 'studentUserId',
  classId: 'classId'
};

exports.Prisma.ClassScalarFieldEnum = {
  id: 'id',
  name: 'name',
  classSize: 'classSize',
  maxClassSize: 'maxClassSize',
  room: 'room',
  hasPalette: 'hasPalette',
  startDate: 'startDate',
  endDate: 'endDate',
  startWeekIndex: 'startWeekIndex',
  endWeekIndex: 'endWeekIndex',
  occursOn: 'occursOn',
  school: 'school',
  format: 'format',
  timeZone: 'timeZone',
  timeBlockName: 'timeBlockName',
  timeBlockStart: 'timeBlockStart',
  timeBlockEnd: 'timeBlockEnd',
  bannerFileKey: 'bannerFileKey',
  courseId: 'courseId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  isMakeup: 'isMakeup'
};

exports.Prisma.ClassZoomMeetingScalarFieldEnum = {
  id: 'id',
  meetingId: 'meetingId',
  meetingLink: 'meetingLink',
  zoomAccountEmail: 'zoomAccountEmail',
  classId: 'classId'
};

exports.Prisma.LessonTeacherScalarFieldEnum = {
  teacherUserId: 'teacherUserId',
  lessonId: 'lessonId',
  subBlockNumber: 'subBlockNumber',
  type: 'type'
};

exports.Prisma.LessonScalarFieldEnum = {
  id: 'id',
  date: 'date',
  classId: 'classId',
  zoomMeetingId: 'zoomMeetingId',
  hostJoined: 'hostJoined'
};

exports.Prisma.KAPlusSubscriptionEventScalarFieldEnum = {
  id: 'id',
  eventType: 'eventType',
  gradeId: 'gradeId',
  subscribedStudentId: 'subscribedStudentId',
  subscribingUserId: 'subscribingUserId',
  scheduledSubscriptionStartDate: 'scheduledSubscriptionStartDate',
  scheduledSubscriptionEndDate: 'scheduledSubscriptionEndDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.EnrollmentHistoryScalarFieldEnum = {
  id: 'id',
  status: 'status',
  classId: 'classId',
  enrolledStudentId: 'enrolledStudentId',
  enrolledById: 'enrolledById',
  scheduledEnrollmentStartDate: 'scheduledEnrollmentStartDate',
  scheduledEnrollmentEndDate: 'scheduledEnrollmentEndDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.BulkEnrollmentFileScalarFieldEnum = {
  id: 'id',
  fileName: 'fileName',
  status: 'status',
  uploadedById: 'uploadedById',
  uploadedOn: 'uploadedOn',
  lastUpdatedById: 'lastUpdatedById',
  lastUpdatedOn: 'lastUpdatedOn',
  completedById: 'completedById',
  completedOn: 'completedOn'
};

exports.Prisma.BulkEnrollmentRowScalarFieldEnum = {
  id: 'id',
  index: 'index',
  fileId: 'fileId',
  courseName: 'courseName',
  schoolYear: 'schoolYear',
  categoryName: 'categoryName',
  className: 'className',
  parentEmail: 'parentEmail',
  studentFullName: 'studentFullName'
};

exports.Prisma.GoogleDriveCourseFolderScalarFieldEnum = {
  id: 'id',
  folderId: 'folderId',
  courseId: 'courseId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.GoogleDriveClassFolderScalarFieldEnum = {
  id: 'id',
  folderId: 'folderId',
  classId: 'classId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.GoogleDriveFileScalarFieldEnum = {
  id: 'id',
  fileId: 'fileId',
  googleDriveFolderId: 'googleDriveFolderId',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.NewsScalarFieldEnum = {
  id: 'id',
  title: 'title',
  imageFileKey: 'imageFileKey',
  url: 'url',
  content: 'content',
  category: 'category',
  status: 'status',
  publishedDate: 'publishedDate',
  restriction: 'restriction',
  gradeByAges: 'gradeByAges',
  isHighlight: 'isHighlight',
  updatedById: 'updatedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.NewsTagScalarFieldEnum = {
  id: 'id',
  newsId: 'newsId',
  tagId: 'tagId'
};

exports.Prisma.NewsCourseScalarFieldEnum = {
  id: 'id',
  newsId: 'newsId',
  courseId: 'courseId'
};

exports.Prisma.ResourceCategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ResourceSubcategoryScalarFieldEnum = {
  id: 'id',
  name: 'name',
  parentCategoryId: 'parentCategoryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ResourceFolderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  module: 'module',
  parentFolderId: 'parentFolderId',
  lastModifiedById: 'lastModifiedById',
  deletedById: 'deletedById',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ResourceFileScalarFieldEnum = {
  id: 'id',
  name: 'name',
  resourceFolderId: 'resourceFolderId',
  type: 'type',
  module: 'module',
  deletedById: 'deletedById',
  deletedAt: 'deletedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ResourceVersionScalarFieldEnum = {
  id: 'id',
  value: 'value',
  coverValue: 'coverValue',
  coverName: 'coverName',
  defaultCoverValue: 'defaultCoverValue',
  isMainVersion: 'isMainVersion',
  resourceFileId: 'resourceFileId',
  lastModifiedById: 'lastModifiedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.HtmlResourceFileContentScalarFieldEnum = {
  id: 'id',
  resourceFileId: 'resourceFileId',
  targetResourceFileId: 'targetResourceFileId'
};

exports.Prisma.ResourceInCourseScalarFieldEnum = {
  id: 'id',
  resourceSubcategoryId: 'resourceSubcategoryId',
  courseId: 'courseId',
  resourceFileId: 'resourceFileId',
  visibilityStatus: 'visibilityStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ResourceInCourseVisibilityRestrictionScalarFieldEnum = {
  id: 'id',
  classId: 'classId',
  studentUserId: 'studentUserId',
  resourceInCourseId: 'resourceInCourseId',
  visibilityStartDate: 'visibilityStartDate',
  visibilityEndDate: 'visibilityEndDate'
};

exports.Prisma.MaterialWeekInCourseScalarFieldEnum = {
  id: 'id',
  weekIndex: 'weekIndex',
  courseId: 'courseId',
  visibilityStatus: 'visibilityStatus',
  visibilityStartDate: 'visibilityStartDate',
  visibilityEndDate: 'visibilityEndDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.DailyMaterialInCourseScalarFieldEnum = {
  id: 'id',
  courseId: 'courseId',
  resourceFileId: 'resourceFileId',
  visibilityStatus: 'visibilityStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WeeklyMaterialInCourseScalarFieldEnum = {
  id: 'id',
  resourceFileId: 'resourceFileId',
  visibilityStatus: 'visibilityStatus',
  materialWeekInCourseId: 'materialWeekInCourseId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.MaterialInCourseVisibilityRestrictionScalarFieldEnum = {
  id: 'id',
  classId: 'classId',
  studentUserId: 'studentUserId',
  dailyMaterialInCourseId: 'dailyMaterialInCourseId',
  weeklyMaterialInCourseId: 'weeklyMaterialInCourseId',
  visibilityStartDate: 'visibilityStartDate',
  visibilityEndDate: 'visibilityEndDate'
};

exports.Prisma.ResourceLastPlayedScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  resourceFileVersionId: 'resourceFileVersionId',
  studyBuddyFrameComponentId: 'studyBuddyFrameComponentId',
  timestamp: 'timestamp',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StudentReportScalarFieldEnum = {
  id: 'id',
  name: 'name',
  year: 'year',
  visibilityStatus: 'visibilityStatus',
  visibilityStartDate: 'visibilityStartDate',
  visibilityEndDate: 'visibilityEndDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StudentReportAssignmentScalarFieldEnum = {
  id: 'id',
  studentUserId: 'studentUserId',
  studentReportId: 'studentReportId',
  visibilityStatus: 'visibilityStatus',
  visibilityStartDate: 'visibilityStartDate',
  visibilityEndDate: 'visibilityEndDate',
  googleDriveFolderId: 'googleDriveFolderId',
  googleDriveFolderStatus: 'googleDriveFolderStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StudyBuddyRootFolderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  lastModifiedById: 'lastModifiedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StudyBuddyLessonFolderScalarFieldEnum = {
  id: 'id',
  name: 'name',
  thumbnailResourceFileId: 'thumbnailResourceFileId',
  weekIndex: 'weekIndex',
  parentRootFolderId: 'parentRootFolderId',
  lastModifiedById: 'lastModifiedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StudyBuddyFrameScalarFieldEnum = {
  id: 'id',
  name: 'name',
  journeyName: 'journeyName',
  parentLessonFolderId: 'parentLessonFolderId',
  lastModifiedById: 'lastModifiedById',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StudyBuddyFrameComponentScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  order: 'order',
  resourceFileId: 'resourceFileId',
  frameId: 'frameId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StudyBuddyLessonFolderInCourseScalarFieldEnum = {
  id: 'id',
  lessonFolderId: 'lessonFolderId',
  courseId: 'courseId',
  visibilityStatus: 'visibilityStatus',
  visibilityStartDate: 'visibilityStartDate',
  visibilityEndDate: 'visibilityEndDate',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StudyBuddyFrameInCourseScalarFieldEnum = {
  id: 'id',
  type: 'type',
  order: 'order',
  studyBuddyFrameId: 'studyBuddyFrameId',
  lessonFolderInCourseId: 'lessonFolderInCourseId',
  visibilityStatus: 'visibilityStatus',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.StudyBuddyFrameInCourseVisibilityRestrictionScalarFieldEnum = {
  id: 'id',
  classId: 'classId',
  studentUserId: 'studentUserId',
  frameInCourseId: 'frameInCourseId',
  visibilityStartDate: 'visibilityStartDate',
  visibilityEndDate: 'visibilityEndDate'
};

exports.Prisma.StudyBuddyStudentCompletedFrameComponentScalarFieldEnum = {
  id: 'id',
  studentUserId: 'studentUserId',
  studyBuddyFrameInCourseId: 'studyBuddyFrameInCourseId',
  studyBuddyFrameComponentId: 'studyBuddyFrameComponentId'
};

exports.Prisma.TaskScalarFieldEnum = {
  id: 'id',
  status: 'status',
  taskType: 'taskType',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  password: 'password',
  isPasswordManuallySet: 'isPasswordManuallySet',
  phoneNumber: 'phoneNumber',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastActivityDate: 'lastActivityDate',
  location: 'location',
  school: 'school',
  pipedriveUserId: 'pipedriveUserId',
  timeZone: 'timeZone'
};

exports.Prisma.AdminScalarFieldEnum = {
  userId: 'userId'
};

exports.Prisma.StudentScalarFieldEnum = {
  userId: 'userId',
  gradeId: 'gradeId',
  yearsAbroad: 'yearsAbroad',
  returnDate: 'returnDate',
  dateOfBirth: 'dateOfBirth',
  parentId: 'parentId',
  kaplusSubscriptionInquiredAt: 'kaplusSubscriptionInquiredAt'
};

exports.Prisma.ParentScalarFieldEnum = {
  userId: 'userId',
  pinCode: 'pinCode'
};

exports.Prisma.TeacherScalarFieldEnum = {
  userId: 'userId'
};

exports.Prisma.RoleScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  isPredefined: 'isPredefined',
  permissions: 'permissions',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refresh_token: 'refresh_token',
  access_token: 'access_token',
  expires_at: 'expires_at',
  token_type: 'token_type',
  scope: 'scope',
  id_token: 'id_token',
  session_state: 'session_state'
};

exports.Prisma.UserInvitationScalarFieldEnum = {
  id: 'id',
  email: 'email',
  token: 'token',
  invitedAt: 'invitedAt',
  expiresAt: 'expiresAt',
  userId: 'userId'
};

exports.Prisma.PersistentErrorScalarFieldEnum = {
  id: 'id',
  type: 'type',
  input: 'input',
  error: 'error'
};

exports.Prisma.ParentStudentInvitationLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  persistentErrorId: 'persistentErrorId',
  parentUserId: 'parentUserId',
  studentUserId: 'studentUserId',
  isNewParent: 'isNewParent'
};

exports.Prisma.RecoveryRequestScalarFieldEnum = {
  id: 'id',
  type: 'type',
  token: 'token',
  createdAt: 'createdAt',
  expiresAt: 'expiresAt',
  updatedAt: 'updatedAt',
  userId: 'userId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.AnnouncementVisibilityStatus = exports.$Enums.AnnouncementVisibilityStatus = {
  VISIBLE: 'VISIBLE',
  HIDDEN: 'HIDDEN',
  DATE_RESTRICTED: 'DATE_RESTRICTED'
};

exports.CalendarVisibilityStatus = exports.$Enums.CalendarVisibilityStatus = {
  VISIBLE: 'VISIBLE',
  HIDDEN: 'HIDDEN',
  DATE_RESTRICTED: 'DATE_RESTRICTED',
  ARCHIVED: 'ARCHIVED'
};

exports.CourseType = exports.$Enums.CourseType = {
  CORE: 'CORE',
  SPECIAL: 'SPECIAL',
  KAPLUS: 'KAPLUS'
};

exports.CourseRecurrence = exports.$Enums.CourseRecurrence = {
  WEEKLY: 'WEEKLY',
  DAILY: 'DAILY'
};

exports.CourseVisibilityStatus = exports.$Enums.CourseVisibilityStatus = {
  VISIBLE: 'VISIBLE',
  HIDDEN: 'HIDDEN',
  ARCHIVED: 'ARCHIVED',
  DATE_RESTRICTED: 'DATE_RESTRICTED'
};

exports.ClassFormat = exports.$Enums.ClassFormat = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  FLEXIBLE: 'FLEXIBLE'
};

exports.DayOfTheWeek = exports.$Enums.DayOfTheWeek = {
  MON: 'MON',
  TUE: 'TUE',
  WED: 'WED',
  THU: 'THU',
  FRI: 'FRI',
  SAT: 'SAT',
  SUN: 'SUN'
};

exports.LessonTeacherType = exports.$Enums.LessonTeacherType = {
  MAIN_TEACHER: 'MAIN_TEACHER',
  CO_TEACHER: 'CO_TEACHER',
  OBSERVER: 'OBSERVER',
  GUEST_TEACHER: 'GUEST_TEACHER',
  SUBSTITUTE_TEACHER: 'SUBSTITUTE_TEACHER'
};

exports.KAPlusSubscriptionEventType = exports.$Enums.KAPlusSubscriptionEventType = {
  SUBSCRIBED: 'SUBSCRIBED',
  UNSUBSCRIBED: 'UNSUBSCRIBED'
};

exports.EnrollmentHistoryStatus = exports.$Enums.EnrollmentHistoryStatus = {
  ENROLLED: 'ENROLLED',
  UNENROLLED: 'UNENROLLED'
};

exports.BulkEnrollmentFileStatus = exports.$Enums.BulkEnrollmentFileStatus = {
  DRAFT: 'DRAFT',
  COMPLETED: 'COMPLETED'
};

exports.NewsCategory = exports.$Enums.NewsCategory = {
  ASSESSMENTS: 'ASSESSMENTS',
  ANNOUNCEMENTS: 'ANNOUNCEMENTS',
  EVENTS: 'EVENTS',
  UPCOMING_COURSES: 'UPCOMING_COURSES'
};

exports.NewsStatus = exports.$Enums.NewsStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
};

exports.NewsRestriction = exports.$Enums.NewsRestriction = {
  NONE: 'NONE',
  GRADE_BY_AGE: 'GRADE_BY_AGE',
  COURSE: 'COURSE'
};

exports.GradeByAge = exports.$Enums.GradeByAge = {
  K1: 'K1',
  K2: 'K2',
  G1: 'G1',
  G2: 'G2',
  G3: 'G3',
  G4: 'G4',
  G5: 'G5',
  G6: 'G6',
  JH1: 'JH1',
  JH2: 'JH2',
  JH3: 'JH3',
  HS1: 'HS1',
  HS2: 'HS2',
  HS3: 'HS3'
};

exports.ResourceModule = exports.$Enums.ResourceModule = {
  RESOURCE: 'RESOURCE',
  MATERIAL: 'MATERIAL'
};

exports.ResourceFileType = exports.$Enums.ResourceFileType = {
  IMAGE: 'IMAGE',
  PDF: 'PDF',
  AUDIO: 'AUDIO',
  HTML: 'HTML',
  VIMEO: 'VIMEO',
  YOUTUBE: 'YOUTUBE',
  GENIALLY: 'GENIALLY',
  H5P: 'H5P',
  LIBSYN: 'LIBSYN',
  CSV: 'CSV',
  GDOCS: 'GDOCS',
  GSHEETS: 'GSHEETS',
  GSLIDES: 'GSLIDES',
  GFORMS: 'GFORMS'
};

exports.ResourceInCourseVisibilityStatus = exports.$Enums.ResourceInCourseVisibilityStatus = {
  VISIBLE: 'VISIBLE',
  HIDDEN: 'HIDDEN',
  DATE_RESTRICTED: 'DATE_RESTRICTED'
};

exports.MaterialInCourseVisibilityStatus = exports.$Enums.MaterialInCourseVisibilityStatus = {
  VISIBLE: 'VISIBLE',
  HIDDEN: 'HIDDEN',
  DATE_RESTRICTED: 'DATE_RESTRICTED'
};

exports.StudentReportVisibilityStatus = exports.$Enums.StudentReportVisibilityStatus = {
  VISIBLE: 'VISIBLE',
  HIDDEN: 'HIDDEN',
  DATE_RESTRICTED: 'DATE_RESTRICTED',
  ARCHIVED: 'ARCHIVED'
};

exports.GoogleDriveFolderStatus = exports.$Enums.GoogleDriveFolderStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};

exports.StudyBuddyFrameInCourseVisibilityStatus = exports.$Enums.StudyBuddyFrameInCourseVisibilityStatus = {
  VISIBLE: 'VISIBLE',
  HIDDEN: 'HIDDEN',
  DATE_RESTRICTED: 'DATE_RESTRICTED'
};

exports.StudyBuddyFrameInCourseType = exports.$Enums.StudyBuddyFrameInCourseType = {
  JOURNEY: 'JOURNEY',
  BONUS: 'BONUS'
};

exports.TaskStatus = exports.$Enums.TaskStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED'
};

exports.TaskType = exports.$Enums.TaskType = {
  ALL: 'ALL',
  CORE: 'CORE',
  SPECIAL: 'SPECIAL'
};

exports.UserStatus = exports.$Enums.UserStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PENDING: 'PENDING'
};

exports.PersistentErrorType = exports.$Enums.PersistentErrorType = {
  USER_INVITATION_INPUT_VALIDATION: 'USER_INVITATION_INPUT_VALIDATION',
  USER_INVITATION_GRADE_DOES_NOT_EXIST: 'USER_INVITATION_GRADE_DOES_NOT_EXIST',
  USER_INVITATION_USER_DOES_NOT_HAVE_PARENT_ROLE: 'USER_INVITATION_USER_DOES_NOT_HAVE_PARENT_ROLE',
  USER_INVITATION_USER_WITH_SAME_PIPEDRIVE_ID_EXISTS: 'USER_INVITATION_USER_WITH_SAME_PIPEDRIVE_ID_EXISTS',
  USER_INVITATION_OTHER_ERROR: 'USER_INVITATION_OTHER_ERROR'
};

exports.RecoveryType = exports.$Enums.RecoveryType = {
  PASSWORD: 'PASSWORD',
  PIN: 'PIN'
};

exports.Prisma.ModelName = {
  Announcement: 'Announcement',
  Calendar: 'Calendar',
  CourseCategory: 'CourseCategory',
  CourseGrade: 'CourseGrade',
  CourseSkill: 'CourseSkill',
  CourseSkillOnCourse: 'CourseSkillOnCourse',
  CourseGradeOnCourse: 'CourseGradeOnCourse',
  Course: 'Course',
  CourseTheme: 'CourseTheme',
  StudentEnrollmentInClass: 'StudentEnrollmentInClass',
  Class: 'Class',
  ClassZoomMeeting: 'ClassZoomMeeting',
  LessonTeacher: 'LessonTeacher',
  Lesson: 'Lesson',
  KAPlusSubscriptionEvent: 'KAPlusSubscriptionEvent',
  EnrollmentHistory: 'EnrollmentHistory',
  BulkEnrollmentFile: 'BulkEnrollmentFile',
  BulkEnrollmentRow: 'BulkEnrollmentRow',
  GoogleDriveCourseFolder: 'GoogleDriveCourseFolder',
  GoogleDriveClassFolder: 'GoogleDriveClassFolder',
  GoogleDriveFile: 'GoogleDriveFile',
  News: 'News',
  Tag: 'Tag',
  NewsTag: 'NewsTag',
  NewsCourse: 'NewsCourse',
  ResourceCategory: 'ResourceCategory',
  ResourceSubcategory: 'ResourceSubcategory',
  ResourceFolder: 'ResourceFolder',
  ResourceFile: 'ResourceFile',
  ResourceVersion: 'ResourceVersion',
  HtmlResourceFileContent: 'HtmlResourceFileContent',
  ResourceInCourse: 'ResourceInCourse',
  ResourceInCourseVisibilityRestriction: 'ResourceInCourseVisibilityRestriction',
  MaterialWeekInCourse: 'MaterialWeekInCourse',
  DailyMaterialInCourse: 'DailyMaterialInCourse',
  WeeklyMaterialInCourse: 'WeeklyMaterialInCourse',
  MaterialInCourseVisibilityRestriction: 'MaterialInCourseVisibilityRestriction',
  ResourceLastPlayed: 'ResourceLastPlayed',
  StudentReport: 'StudentReport',
  StudentReportAssignment: 'StudentReportAssignment',
  StudyBuddyRootFolder: 'StudyBuddyRootFolder',
  StudyBuddyLessonFolder: 'StudyBuddyLessonFolder',
  StudyBuddyFrame: 'StudyBuddyFrame',
  StudyBuddyFrameComponent: 'StudyBuddyFrameComponent',
  StudyBuddyLessonFolderInCourse: 'StudyBuddyLessonFolderInCourse',
  StudyBuddyFrameInCourse: 'StudyBuddyFrameInCourse',
  StudyBuddyFrameInCourseVisibilityRestriction: 'StudyBuddyFrameInCourseVisibilityRestriction',
  StudyBuddyStudentCompletedFrameComponent: 'StudyBuddyStudentCompletedFrameComponent',
  Task: 'Task',
  User: 'User',
  Admin: 'Admin',
  Student: 'Student',
  Parent: 'Parent',
  Teacher: 'Teacher',
  Role: 'Role',
  Account: 'Account',
  UserInvitation: 'UserInvitation',
  PersistentError: 'PersistentError',
  ParentStudentInvitationLog: 'ParentStudentInvitationLog',
  RecoveryRequest: 'RecoveryRequest'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
